/* /musko-sisanje (/en/mens-haircut, /de/herrenhaarschnitt)

   Split out of /hairdresser, which now carries a single line and a link
   instead of a full section. Prices come from HAIR.musko in
   src/config/prices.mjs, in that order: classic cut, fade, wash. */

import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Bredcrumb from '../../HomeMain/Bredcrumb';
import Appointment from '../../HomeMain/Appointment';
import Faq from '../../ui/Faq';
import {
  Section, Heading, P, PriceTable, PriceList, buttonStyle, INK,
} from '../../ui/blocks';
import { HAIR } from '../../../config/prices.mjs';

const Main = () => {
  const { t } = useTranslation();

  const priceRows = t('mensHaircut.pricing.rows', { returnObjects: true })
    .map((label, i) => ({ label, price: HAIR.musko[i] }));
  const faq = t('mensHaircut.faq.items', { returnObjects: true });

  return (
    <>
      <Bredcrumb title={t('pages.mensHaircut.title')} subtitle={t('pages.mensHaircut.subtitle')} />

      <Section>
        <P style={{ fontSize: '18px', color: INK, fontWeight: 500, marginBottom: 0 }}>
          {t('mensHaircut.intro.p1')}
        </P>
      </Section>

      <PriceList title={t('mensHaircut.pricing.heading')}>
        <PriceTable rows={priceRows} note={t('mensHaircut.pricing.note')} />
      </PriceList>

      <Section>
        <Heading>{t('mensHaircut.appointment.heading')}</Heading>
        <P>{t('mensHaircut.appointment.p1')}</P>
        <P>{t('mensHaircut.appointment.p2')}</P>
        <P style={{ marginBottom: 0 }}>{t('mensHaircut.appointment.p3')}</P>
      </Section>

      <Section tinted>
        <Heading align="center">{t('mensHaircut.faq.heading')}</Heading>
        <Faq items={faq} />
      </Section>

      {/* Same booking form as /contact, pre-filled with this page's service. */}
      <Appointment defaultService="Muško šišanje" />


      <Section>
        <div style={{ textAlign: 'center' }}>
          <Link to="/hairdresser" style={buttonStyle('outline')}>
            {t('hairdresserService.breadcrumbTitle')}
          </Link>
        </div>
      </Section>
    </>
  );
};

export default Main;
